module.exports = __webpack_public_path__ + "img/image60.41ca1643.png";